var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 44,
    viewBox: "0 0 68 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.248 0.681702C24.4898 0.681702 18.4703 3.88777 14.6013 8.87304H10.9784C5.29375 8.87303 0.667969 13.5367 0.667969 19.2716V25.5417C0.667969 31.2766 5.29375 35.9432 10.9784 35.9432H15.2656C19.1413 40.46 24.8657 43.3183 31.248 43.3183C37.6303 43.3183 43.3547 40.46 47.2304 35.9432H51.3581C57.045 35.9432 61.6716 31.2766 61.6716 25.5417V19.2716C61.6716 13.5367 57.045 8.87304 51.3581 8.87304H47.8948C44.0257 3.88777 38.0062 0.681702 31.248 0.681702Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5777 25.5411V19.2729C32.5777 14.6424 36.3132 10.8739 40.9032 10.8739H51.3586C55.9487 10.8739 59.6863 14.6424 59.6863 19.2729V25.5411C59.6863 30.1717 55.9487 33.9401 51.3586 33.9401C51.3586 33.9401 35.9983 33.9401 28.3379 33.9401C30.906 32.047 32.5777 28.9874 32.5777 25.5411Z",
    fill: "#342E6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9882 28.7941H15.5567L14.9422 25.8544C14.5039 23.768 14.1009 21.2327 14.0238 20.2484C13.9445 21.2327 13.5436 23.768 13.1053 25.8544L12.4886 28.7941H9.09674L5.89648 15.2556H9.72886L10.0923 17.5198C10.4006 19.4351 10.7662 21.7949 10.8984 23.3991C11.0526 21.8126 11.4733 19.4707 11.8961 17.5354L12.3543 15.2556H15.7682L16.2285 17.5354C16.6492 19.4707 17.0699 21.8126 17.2262 23.3991C17.3584 21.7949 17.724 19.4351 18.0302 17.5198L18.3936 15.2556H22.1907L18.9882 28.7941Z",
    fill: "#342E6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5538 17.9064C24.4217 17.9064 23.5781 17.2465 23.5781 16.1866C23.5781 15.1978 24.4217 14.5024 25.5538 14.5024C26.7409 14.5024 27.5647 15.1978 27.5647 16.1866C27.5647 17.2465 26.7409 17.9064 25.5538 17.9064ZM23.827 28.7941V18.9596H27.2784V28.7941H23.827Z",
    fill: "#342E6D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9619 18.4464V21.4727H48.1025V24.6479H40.9619V28.7941H37.2617V15.2556H48.8624V18.4464H40.9619Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7374 17.9064C51.6075 17.9064 50.7617 17.2465 50.7617 16.1866C50.7617 15.1978 51.6075 14.5024 52.7374 14.5024C53.9245 14.5024 54.7483 15.1978 54.7483 16.1866C54.7483 17.2465 53.9245 17.9064 52.7374 17.9064ZM51.0128 28.7941V18.9596H54.462V28.7941H51.0128Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1106 12.7136V10.3317H62.2715V9.84509H64.5225V10.3317H63.6811V12.7136H63.1106Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8867 12.7136V9.84509H65.7501L66.2589 11.8026L66.7611 9.84509H67.6244V12.7136H67.0958L67.0914 10.4561L66.5342 12.7136H65.9792L65.4197 10.4561L65.4153 12.7136H64.8867Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.320c55cd5e111744c007ba3d632ea6ce.svg";
export { ForwardRef as ReactComponent };